<pace-forms2>
    <div class="col mt-3 px-4 py-2 card">
        @if (notification$ | async; as notification) {
            <pace-header [notification]="notification.model">
                <div class="row my-1">
                    <a
                        class="col-12 col-lg-auto btn btn-link text-start"
                        (click)="openEquipmentHistory(notification.model)"
                    >
                        <strong translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENTS_TITLE"></strong> -
                        <strong translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENT_HISTORY"></strong>
                    </a>
                    <a
                        class="col-12 col-lg-auto btn btn-link text-start"
                        (click)="openEquipmentConfig(notification.model)"
                    >
                        <strong translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENTS_TITLE"></strong> -
                        <strong translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENT_SUB_EQUIPMENT"></strong>
                    </a>
                </div>
                <div class="row my-1">
                    <div class="col-4 d-none d-lg-block">
                        @if (notification.model.userStatus) {
                            <fa-icon class="me-1" [icon]="faFlag"></fa-icon>
                        }
                        <span>{{ notification.model.userStatus }}</span>
                    </div>
                    <div class="col-4 d-none d-lg-block">
                        <pace-notification-status-badge
                            [notification]="notification.model"
                            [notificationStatus]="notification.status"
                            [showUnreadIcon]="false"
                        ></pace-notification-status-badge>
                    </div>
                </div>
            </pace-header>
        }
    </div>
</pace-forms2>
